'use strict';

angular.module('teams').controller('TeamMembersController',
  ['$scope', '$stateParams', '$state', '$modal', '$location', 'Authentication', 'TeamMembers','Teams', 'SubscriptionMain', 'Utilities', '$window',
    function($scope, $stateParams, $state, $modal, $location, Authentication, TeamMembers, Teams, SubscriptionMain, Utilities, $window) {
        $scope.authentication = Authentication;
		$scope.currentSubscription = {};
		$scope.isAdmin = false;
		$scope.roleInApp = 'none';
		$scope.teamMembers = [];

		if ($scope.authentication.user.username === 'superadmin' && $scope.authentication.user.email === 'superadmin@applanga.com') {
			$scope.isAdmin = true;
		}

		/**
		 * Returns the owner of the team from a list of team members
		 */
		$scope.getTeamOwner = function(teamMembers) {
			for (var i=0;i<teamMembers.length;i++) {
				var teamMember = teamMembers[i];
				if (teamMember.role === 'owner') {
					return teamMember.user;
				}
			}

			return undefined;
		};


		/**
		 * Returns the current role in app
		 */
		$scope.getCurrentRoleInApp = function () {
			var userId = $scope.authentication.user._id;

			if ($scope.authentication.user.username === 'superadmin' && $scope.authentication.user.email === 'superadmin@applanga.com') {
				$scope.roleInApp = 'superadmin';
			} else {
				for (var i = 0; i < $scope.teamMembers.length; i++) {
					if (userId === $scope.teamMembers[i].user._id) {
						$scope.roleInApp = $scope.teamMembers[i].role;
					}
				}
			}
		};

		/**
		 * Returns if an additional team member can get added or not
		 */
		$scope.canUserAddTeamMembers = function() {
			if ($scope.currentSubscription && $scope.currentSubscription.teamMembers && $scope.currentSubscription.usedTeamMembers) {
				if ($scope.currentSubscription.usedTeamMembers < $scope.currentSubscription.teamMembers) {
					return true;
				}
			}
			return false;
		};


		// Invite a not existing user
		function inviteUser(email, role) {

			var modalInstance = $modal.open({
				templateUrl: 'modules/teams/views/invite-user-modal.client.view.html',
				controller: 'InviteUserModalController',
				size: 'md',
				resolve: {
					inputData: function() {
						return {
							email: email,
							role: role,
							teamId: $stateParams.teamId
						};
					}
				}
			});

			modalInstance.result.then(function (userData) {
				$location.path('teams/' + $stateParams.teamId );
			});
		}


        // Create new Team Member
        $scope.create = function() {

			// Before we send the data to the server we make sure that a role
			// got selected
			if (!$scope.role) {
				$scope.error = 'Please select a role for the User.';
				return;
			}

            // Create new Team Member object
            var teamMember = new TeamMembers ({
                username: this.username,
                role: this.role
            });

            // Redirect after save
            teamMember.$save({
                teamId: $stateParams.teamId
            },function(response) {
                $location.path('teams/' + $stateParams.teamId );

                // Clear form fields
                $scope.name = '';
            }, function(errorResponse) {

				if (errorResponse.data.upgradeRequired === true) {
					// User reached the subscription limit

					// Find the team owner to be able to display the correct modal
					$scope.findOneTeam(function(err, team) {
						if (err) {
							Utilities.showMessage(
								'Error!',
								'There was a problem finding the team owner. Please contact the support! Thanks!',
								'error'
							);
							return;
						}

						// Display the upgrade modal and let user upgrade if he is the team owner
						Utilities.upgradeSubscriptionTeam('teamMembers', team.user, $scope.authentication.user, $stateParams.teamId,
							function(err, gotUpgraded) {
								if (gotUpgraded === true) {
									// Reload the new subscription
									SubscriptionMain.getUserPlan(true, function() {});
								}
							}
						);
					});
					return;
				}


				if (errorResponse.status === 404) {
					// User does not exist
					inviteUser($scope.username, $scope.role);
				} else {
					// Other problem adding user to team
					$scope.error = errorResponse.data.message;
				}

            });
        };

        // Remove existing Team
        $scope.remove = function(teamMember) {
            if ( teamMember ) {
                teamMember.$remove({
                    teamId: $stateParams.teamId
                }, function(errorResponse) {
                    $scope.error = errorResponse.data.message;
                });

                for (var i in $scope.teamMembers) {
                    if ($scope.teamMembers [i] === teamMember) {
                        $scope.teamMembers.splice(i, 1);
                    }
                }
            } else {
                $scope.teamMember.$remove({
                    teamId: $stateParams.teamId
                }, function() {
                    $location.path('teams/' + $stateParams.teamId);
                }, function(errorResponse) {
                    $scope.error = errorResponse.data.message;
                });
            }
        };

        // Update existing Team
        $scope.update = function() {
            var teamMember = $scope.teamMember;

            teamMember.$update({
                teamId: $stateParams.teamId
            },function() {
                $location.path('teams/' + $stateParams.teamId +'/team-members/' +  teamMember._id);
            }, function(errorResponse) {
                $scope.error = errorResponse.data.message;
            });
        };

		// Find existing Team
		$scope.findOneTeam = function(callback) {
			$scope.team = Teams.get({
				teamId: $stateParams.teamId
			},function(response){
				if (callback) {
					callback(null,response);
				}
			},function(err){
				if (callback) {
					callback(err);
				}
			});
		};

        // Find a list of Teams
        $scope.find = function() {
			$scope.roleDisplayNames = {
                'owner': ' OWNER ',
                'admin': ' ADMINISTRATOR ',
                'manager': ' MANAGER ',
				'translator': ' TRANSLATOR / REVIEWER ',
				'tptadmin': ' TPT ADMIN ',
				'tptservices': ' TPT MANAGER ',
				'tpttranslator': ' TPT TRANSLATOR / REVIEWER '
			};
            $scope.teamId = $stateParams.teamId;
            $scope.findOneTeam(function(err, teamInfo) {
				if (!err) {
					$scope.teamMembers = teamInfo.members;
					$scope.currentSubscription = teamInfo.planInfo;
				}
			});
        };

        // Find existing Team
        $scope.findOne = function() {
            $scope.findOneTeam();
            $scope.roleDisplayNames = {
                'owner': ' OWNER ',
                'admin': ' ADMINISTRATOR ',
                'manager': ' MANAGER ',
				'translator': ' TRANSLATOR / REVIEWER ',
				'tptadmin': ' TPT ADMIN ',
				'tptservices': ' TPT MANAGER ',
				'tpttranslator': ' TPT TRANSLATOR / REVIEWER '
            };
			$scope.teamId = $stateParams.teamId;
			Teams.get({
				teamId: $stateParams.teamId,
			}, 	function (response) {
					$scope.teamMembers = response.members;
					$scope.getCurrentRoleInApp();
			}, 	function (errResponse) {
					return;
			});
			if ($stateParams.teamMemberId !== undefined) {
				$scope.teamMember = TeamMembers.get({
					teamId: $stateParams.teamId,
					teamMemberId: $stateParams.teamMemberId
				});
			}
        };
    }
]);
